import { render, staticRenderFns } from "./users_new.vue?vue&type=template&id=96913370&scoped=true"
import script from "./users_new.vue?vue&type=script&lang=js"
export * from "./users_new.vue?vue&type=script&lang=js"
import style0 from "./users_new.vue?vue&type=style&index=0&id=96913370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96913370",
  null
  
)

export default component.exports